/**
 * Utilidades para fase VICO-383: autorizaciones pending y cierre vía webhook.
 */

export const PAYMENT_POLL_INTERVAL_MS = 3000;
export const PAYMENT_POLL_MAX_ATTEMPTS = 40;

export function getPendingTypesFromMakePaymentsResponse(response) {
    const detail = response?.detail;
    if (!Array.isArray(detail)) {
        return [];
    }
    return detail
        .filter((item) => item?.status === "pending")
        .map((item) => item.type)
        .filter(Boolean);
}

export function hasMakePaymentsHardFailure(response) {
    if (!response) {
        return true;
    }
    const detail = response.detail;
    if (Array.isArray(detail) && detail.some((item) => item?.status === "error")) {
        return true;
    }
    if (response.hasPending) {
        return false;
    }
    return response.status !== true;
}

export function balanceChargesSettled(account) {
    const balance = account?.balance;
    if (!balance?.charges?.length) {
        return true;
    }
    const chargesTotal = balance.charges_total;
    if (chargesTotal == null) {
        return false;
    }
    return (balance.payments || []).some((pay) => pay?.amount === chargesTotal);
}

/**
 * Evalúa si el polling puede terminar tras un getAccount.
 * @returns {{ resolved: boolean, ok?: boolean, reason?: string }}
 */
export function evaluatePendingPaymentResolution(account, pendingTypes = []) {
    const dg = account?.depositGuarantee || {};
    const types = pendingTypes.length ? pendingTypes : ["security_deposit"];

    if (dg.failed || dg.status === "failed") {
        return {
            resolved: true,
            ok: false,
            reason: dg.failedReasons || null,
        };
    }

    if (types.includes("security_deposit")) {
        const depositOk = dg.paid === true || (dg.status === "retained" && dg.checkedAt);
        if (!depositOk) {
            return { resolved: false };
        }
    }

    if (types.includes("webcheckin") && !balanceChargesSettled(account)) {
        return { resolved: false };
    }

    return { resolved: true, ok: true };
}

export function shouldStartPendingPoll(makePaymentsResponse) {
    return Boolean(makePaymentsResponse?.hasPending) && !hasMakePaymentsHardFailure(makePaymentsResponse);
}
